export default "__VITE_ASSET__08870e58__"